import { DomainInfo } from '_backend/integration/domain-info';

export interface MarketPageDescriptor {
  key: string;
  locale: string;
  path: string;
  countryIso31661: string | null;
  hosts: readonly string[];
}

export interface FindMarketPageKeyParams {
  origin: string;
  locale: string;
  pathname: string;
}

const isServedByOrigin = (page: MarketPageDescriptor, origin: string): boolean => {
  const { hostname } = new URL(origin);
  if (page.hosts.includes(hostname)) return true;
  const marketIso31661 = DomainInfo.getFromOrigin(origin)?.getIso31661();
  return marketIso31661 !== undefined && marketIso31661 === page.countryIso31661;
};

export const findMarketPageKey = (
  descriptors: readonly MarketPageDescriptor[],
  params: FindMarketPageKeyParams,
): string | null => {
  const { origin, locale, pathname } = params;
  const cleanPath = pathname.split('?')[0].replace(/\/$/, '');

  return (
    descriptors.find((page) => page.locale === locale && page.path === cleanPath && isServedByOrigin(page, origin))
      ?.key ?? null
  );
};
